import { createContext, useContext } from 'react';

export type AuthContextValues = {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
  signup: () => void;
  changePassword: () => void;
  refreshTokenIfNecessary: () => void;
};

const defaultContextValues: AuthContextValues = {
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
  signup: () => {},
  changePassword: () => {},
  refreshTokenIfNecessary: () => {}
};

export const AuthContext =
  createContext<AuthContextValues>(defaultContextValues);
export const useAuth = () => useContext(AuthContext);
